export const SSO_ALREADY_REDIRECTED_KEY = 'sso-already-redirected';

export const iconsFolder = `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/production/static/img`;

export const flows = {
  signUp: {
    default: 'sign-up',
    existingAccount: 'existing-account',
    newAccount: 'new-account',
  },
};

const authConstants = {
  flows,
  SSO_ALREADY_REDIRECTED_KEY,
  iconsFolder,
  userType: {
    teacher: 'teacher',
    student: 'student',
    admin: 'admin',
  },
  redirects: {
    signUpSuccess: '/sign-up/success',
    signUpError: '/sign-up/subscription-types/',
  },
};

export default authConstants;
